import Button from "components/base/Button";
import Trans from "components/base/Trans";
import { MotionBox as Box } from "utils/motion";

export default function LoadMoreButton({ onClick, isLoading }) {
  return (
    <Box mt={30} align="center">
      <Button
        isLoading={isLoading}
        loadingText={<Trans id="LBL_BLOG_LOADING" />}
        onClick={onClick}
        variant="outline"
        trackLabel="blog_see_more"
        colorScheme="black"
      >
        <Trans id="LBL_BLOG_LOAD_MORE" />
      </Button>
    </Box>
  );
}
